import * as React from "react";
import type { JSX } from 'react';
import { connect } from "react-redux";
import * as Redux from "redux";
import { AnyAction, Dispatch } from "redux";
import { GetUserInfo } from "../../../business/Profile/ProfileEpics";
import { getUserInfoSelector } from "../../../business/Profile/ProfileSelectors";
import { RootState } from "../../../business/root-store";
import { LegacyMatch, withMatch } from "../../../business/router/with-match";
import { GetUserInfoResponse } from "../../../client";
import { ProfilePageComponent } from "./ProfilePageComponent";

interface IProfilePageContainerReduxMergedProps {
  userInfo: GetUserInfoResponse;
}

interface IProfilePageContainerOwnProps {
  match: LegacyMatch<{ id?: string }>;
}

interface IProfilePageContainerDispatchProps {
  getUserInfo: (userId: number) => void;
}

interface IProfilePageContainerProps
  extends IProfilePageContainerOwnProps,
    IProfilePageContainerDispatchProps,
    IProfilePageContainerReduxMergedProps {}

interface IProfilePageComponentState {}

class ProfilePageContainer extends React.Component<
  IProfilePageContainerProps,
  IProfilePageComponentState
> {
  constructor(
    props: IProfilePageContainerProps,
    state: IProfilePageComponentState
  ) {
    super(props, state);
    this.state = this.getInitialState();
    const userIdFromUrl = Number(this.props.match.params.id);
    this.props.getUserInfo(userIdFromUrl);
  }

  public render(): JSX.Element {
    return (
      <ProfilePageComponent
        userInfo={this.props.userInfo}
        userId={Number(this.props.match?.params?.id ?? -1)}
      />
    );
  }

  public static mapStateToProps = (
    state: RootState,
    ownProps: IProfilePageContainerOwnProps
  ): IProfilePageContainerReduxMergedProps => {
    return {
      userInfo: getUserInfoSelector(state.profile),
    };
  };

  public static mapDispatchToProps = (
    dispatch: Dispatch<AnyAction>
  ): IProfilePageContainerDispatchProps => {
    return {
      ...Redux.bindActionCreators(
        {
          getUserInfo: GetUserInfo,
        },
        dispatch
      ),
    };
  };

  private getInitialState = (): IProfilePageComponentState => {
    return {} as IProfilePageComponentState;
  };
}
export const ProfilePage = withMatch(
  connect(
    ProfilePageContainer.mapStateToProps,
    ProfilePageContainer.mapDispatchToProps
  )(ProfilePageContainer) as unknown as React.ComponentType<{
    match: LegacyMatch<{ id?: string }>;
  }>
);
